import React, {FunctionComponent} from "react";
import {makeStyles} from "@material-ui/core";
import Text from "./Text";
import SvgButton from "./SvgButton";
import minusIcon from "../images/Icons/minus-button_icn.svg";
import plusIcon from "../images/Icons/plus-button_icn.svg";

type WeigthInputProps = {
    weight: number;
    width: number;
    onIncrement: () => void;
    onDecrement: () => void;
};

const useStyles = makeStyles(() => ({
    contentContainer: {
        display: "flex",
        alignItems: "center",
        marginTop: 10,
        justifyContent: "space-between"
    },
    gapFiller: {
        width: 26
    }
}));

const WeigthInput: FunctionComponent<WeigthInputProps> = ({weight, width, onIncrement, onDecrement}) => {

    const classes = useStyles();

    return (
        <div>
            <Text value={"Gewicht"} size={12}/>
            <div>
                <div className={classes.contentContainer} style={{width}}>
                    <SvgButton svg={minusIcon} onClick={onDecrement}/>
                    <Text value={weight + " kg"} size={21}/>
                    <SvgButton svg={plusIcon} onClick={onIncrement}/>
                </div>
            </div>
        </div>
    );
};

export default WeigthInput;
